import { Item } from "@/components/Filters/GenericFilter";
import card_data from "@/data/union_arena/card_data.json";

export function getBattlePowerData(): Item[] {
  let data: Item[] = [];

  for (const card of Object.values(card_data)) {
    if (card.battle_power) {
      //   let power = card.battle_power.replace(/[+\-±]+$/, "");
      if (!data.some((item) => item.key === card.battle_power)) {
        data.push({ key: card.battle_power, value: card.battle_power });
      }
    }
  }

  // Sort by numeric value, then by suffix order: no suffix, -, +, ±
  data.sort((a, b) => {
    const aNum = parseInt(a.key.replace(/[+\-±]+$/, "")) || 0;
    const bNum = parseInt(b.key.replace(/[+\-±]+$/, "")) || 0;

    if (aNum !== bNum) {
      return aNum - bNum;
    }

    // If numeric values are equal, sort by suffix
    const aSuffix = a.key.match(/[+\-±]+$/)?.[0] || "";
    const bSuffix = b.key.match(/[+\-±]+$/)?.[0] || "";

    const suffixOrder = { "": 0, "-": 1, "+": 2, "±": 3 };
    return (
      (suffixOrder[aSuffix as keyof typeof suffixOrder] || 0) -
      (suffixOrder[bSuffix as keyof typeof suffixOrder] || 0)
    );
  });

  return data;
}

export function getCostData(): Item[] {
  let data: Item[] = [];

  for (const card of Object.values(card_data)) {
    if (card.energy_cost) {
      if (!data.some((item) => item.key === card.energy_cost)) {
        data.push({ key: card.energy_cost, value: card.energy_cost });
      }
    }
  }

  data.sort((a, b) => {
    const aNum = parseInt(a.key) || 0;
    const bNum = parseInt(b.key) || 0;
    return aNum - bNum;
  });

  return data;
}
